export default __webpack_public_path__ + "static/media/Hannah 9781846162527.327ece63.jpg";